import React, { useState } from 'react';
import './styles/charts.css';
import moment from 'moment';
import { BOBADMIN } from '../../../utils/Constants';
import { Icon, Select } from 'antd';
const { Option } = Select;


const ChartHeader = ({ headerName, date, callCount, dateTo, userType }) => {

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";

        const date = moment(dateString);
        if (!date.isValid()) return "Invalid Date";

        return date.format("MM/DD/YYYY");
    };


    return (
        <div className='custom-header'>
            {/* Top row: static heading and date */}
            <div className='custom-header-flex'>
                <div style={{ fontSize: '18px', fontWeight: '600' }}>{headerName}</div>
                <div className='custom-text'>
                    {formatDate(date)} - {formatDate(dateTo)}
                </div>
            </div>

            {/* Bottom row: total actions */}
            <div className='custom-header-flex' style={{ marginTop: 12 }}>
                <div className='custom-text'>Total Actions: {callCount}</div>
            </div>
        </div>
    );
};

export default ChartHeader;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/ChartHeader.js